export default "__VITE_ASSET__fcc04d8b__"